import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
// import "./pdf.css";
import PropertyPhTenPdf from "./PropertyPhTenPdf";
import ReactPDF, {
  Document,
  Page,
  PDFViewer,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";
import { Spin } from "antd";
import "./pdf.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as taxCollectionActions from "../../../../../actionCreators/TaxCollection";
import PropertyPhTenBacksidePdf from "./PropertyPhTenBacksidePdf";

const PhTenFormBulk = ({ PH10s, createPH10 }) => {
  const location = useLocation();
  let data = location.state.data;
  const value = useRef(null);
  const [newDataLoaded, setNewDataLoaded] = useState(false);
  useEffect(() => {
    if (data) {
      createPH10(data);
    }
  }, [data]);
  useEffect(() => {
    setTimeout(async () => {
      if (PH10s.data !== null && newDataLoaded) {
        try {
          const pdf = new jsPDF("p", "mm", "a4");
          for (let index = 0; index < data.length * 2; index++) {
            const input = value.current.children[index];
            await html2canvas(input).then((canvas) => {
              let imgWidth = 175;
              let imgHeight = (canvas.height * imgWidth) / canvas.width;
              let position = 0;
              let positionY = 15;
              let imgData = canvas.toDataURL("image/png");
              pdf.addImage(
                imgData,
                "JPEG",
                positionY,
                position + 5,
                imgWidth,
                imgHeight
              );
              if (index < data.length * 2 - 1) {
                pdf.addPage();
              }
            });
          }
          window.open(pdf.output("bloburl"), "_blank");
        } catch (e) {}
      }
    }, 0);
    setNewDataLoaded(true);
  }, [PH10s]);

  if (PH10s.data !== null) {
    return (
      <div
        ref={value}
        style={{
          paddingTop: 500,
          backgroundColor: "#fff",
        }}
      >
        {Object.keys(PH10s.data).map((index, indexKey) => {
          return (
            <>
              <div
                key={indexKey * 2}
                style={
                  indexKey === 0
                    ? {
                        transform: "rotate(90deg)",
                      }
                    : {
                        transform: "rotate(90deg)",
                        marginTop: "150%",
                      }
                }
              >
                <PropertyPhTenPdf data={PH10s.data[index]} />
              </div>

              <div
                id="Artboard__2"
                key={indexKey * 2 + 1}
                style={{
                  transform: "rotate(90deg)",
                  marginTop: "50%",
                }}
              >
                <PropertyPhTenBacksidePdf data={PH10s.data[index]} />
              </div>
            </>
          );
        })}
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin />
      </div>
    );
  }
};

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    height: 1000,
  },
  section: {
    margin: 10,
    padding: 10,
  },
  viewer: {
    width: window.innerWidth, //the pdf viewer will take up all of the width and height
    height: window.innerHeight,
  },
});

const mapStateToProps = ({ taxCollection: { PH10s } }) => ({
  PH10s,
});

const mapDispatchToProps = (dispatch) => ({
  createPH10: bindActionCreators(taxCollectionActions.createPH10, dispatch),
});

PhTenFormBulk.propTypes = {
  PH10s: PropTypes.object.isRequired,
  createPH10: PropTypes.func.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(PhTenFormBulk);
